import {
  POST_PAYMENT_REQUEST,
  POST_PAYMENT_SUCCESS,
  POST_PAYMENT_FAIL,
  POST_WELFARE_BENEFITS_REQUEST,
  POST_WELFARE_BENEFITS_SUCCESS,
  POST_WELFARE_BENEFITS_FAIL,
  POST_IMPORTANT_INFORMATION_REQUEST,
  POST_IMPORTANT_INFORMATION_SUCCESS,
  POST_IMPORTANT_INFORMATION_FAIL,
  GET_PAYMENT_REQUEST,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_FAIL,
  GET_WELFARE_BENEFITS_REQUEST,
  GET_WELFARE_BENEFITS_SUCCESS,
  GET_WELFARE_BENEFITS_FAIL,
  GET_IMPORTANT_INFORMATION_REQUEST,
  GET_IMPORTANT_INFORMATION_SUCCESS,
  GET_IMPORTANT_INFORMATION_FAIL,
} from "../constants/EmployeeFinancialConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const PostPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case POST_PAYMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case POST_PAYMENT_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const PostWelfareBenefitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_WELFARE_BENEFITS_REQUEST:
      return { ...state, loading: true, error: null };
    case POST_WELFARE_BENEFITS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case POST_WELFARE_BENEFITS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const PostImportantInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_IMPORTANT_INFORMATION_REQUEST:
      return { ...state, loading: true, error: null };
    case POST_IMPORTANT_INFORMATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case POST_IMPORTANT_INFORMATION_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// ── get reducers ────────────────────────────────────────────
export const GetPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_PAYMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case GET_PAYMENT_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetWelfareBenefitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WELFARE_BENEFITS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_WELFARE_BENEFITS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case GET_WELFARE_BENEFITS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetImportantInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMPORTANT_INFORMATION_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_IMPORTANT_INFORMATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case GET_IMPORTANT_INFORMATION_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};